import React from 'react';
import {
  Link,
} from '../../../coreui';

const AccredGTKYDenied = () => {
  return (
    <React.Fragment>
      Securities regulations restrict that only fully approved accredited investors can invest in
      Private Placement opportunities. If you believe your accreditation status has
      changed, please call us at <Link type="L4" href="tel:18777817062">(877) 781-7062</Link> or
      email: <Link type="L4" href="mailto:investor-help@realtymogul.com">
        investor-help@realtymogul.com
      </Link>
    </React.Fragment>
  );
};

export default AccredGTKYDenied;
